<div class="container-fluid">
  <p><strong>Personal Details</strong></p>
  <div class="row">
    <!--Operative Image-->
    <div class="col-md-2">
      <app-eca-image-viewer [imageSrc]="operative.image"
                            [isSrcEncoded]="true"
                            [enableEdit]="editingOperativeDetails"
                            (imageOutput)="addOperativeImage($event)">
      </app-eca-image-viewer>
    </div>
    <div class="col-md-10">
      <div class="row">
        <!--First Name-->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <app-eca-input label="First Name" [controlId]="'ctrlFirstName'" [isRequired]="true" [isReadOnly]="!editingOperativeDetails"
                         [isValid]="!saveAttempted || !!operative.firstName"
                         validationMessage="Please enter a first name" popoverText="Please enter the first name for the operative."
                         [(value)]="operative.firstName">
          </app-eca-input>
        </div>
        <!--Middle Initial-->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <app-eca-input label="Middle Initials" [controlId]="'ctrlMiddleInitials'" [isRequired]="false"
                         [isReadOnly]="!editingOperativeDetails" popoverText="Please enter the middle initials for the operative."
                         [(value)]="operative.middleInitials">
          </app-eca-input>
        </div>
        <!--Last Name-->
        <div class="col-lg-4 col-md-6 col-sm-12">
          <app-eca-input label="Last Name" [isRequired]="true" [controlId]="'ctrlLastName'"
                         [isReadOnly]="!editingOperativeDetails || !isNewOperativeSelected()"
                         [isValid]="!saveAttempted || !!operative.lastName"
                         validationMessage="Please enter a last name"
                         (valueChange)="lastNameChanged($event)" popoverText="Please enter the last name for the operative."
                         [(value)]="operative.lastName">
          </app-eca-input>
        </div>
      </div>
      <div class="row">
        <!--Reference Numbers-->
        <div class="col-xl-4 col-md-6 col-sm-12">
          <app-eca-input label="Reference/Card Numbers" [isRequired]="false" [controlId]="'ctrlReferenceCardNumber'"
                         [isReadOnly]="!editingOperativeDetails"
                         [(value)]="operative.referenceNumbers"
                         popoverText="You can store card numbers or any other reference number here to help identify the operative in your records">
          </app-eca-input>
        </div>
        <!--Phone Number-->
        <div class="col-xl-3 col-md-6 col-sm-12">
          <app-eca-input label="Phone Number" [isRequired]="false" [inputType]="'number'" [controlId]="'ctrlPhoneNumber'"
                         [isReadOnly]="!editingOperativeDetails" popoverText="Please enter the phone number for the operative."
                         [(value)]="operative.phoneNumber">
          </app-eca-input>
        </div>
        <!--Email-->
        <div class="col-xl-5 col-md-6 col-sm-12">
          <app-eca-input label="Email Address" [controlId]="'ctrlEmailAddress'"
                         [inputType]="'email'" popoverText="Please enter the email address for the operative."
                         [isValid]="validateEmail(operative.emailAddress)"
                         [isRequired]="false"
                         [isReadOnly]="!editingOperativeDetails"
                         [(value)]="operative.emailAddress">
          </app-eca-input>
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="margin-bottom: 20px" *ngIf="matchingOperatives && matchingOperatives.length > 0 && showMatchingOperatives">
    <div class="col">
      <p-panel class="our-form-background">
        <ng-template pTemplate="header" class="eca-secondary-bg" style="color: white;">
          <div class="row d-flex justify-content-between align-content-center">
            <div class="col-auto">
              <h5 style="margin-bottom: 0 !important;">
                Similar past or present operatives
              </h5>
            </div>
            <div class="col">
              <button class="float-right" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hideMatchingOperative()">
                <fa-icon [icon]="['far', 'times-circle']">  </fa-icon>
              </button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <p-table [totalRecords]="matchingOperatives?.length" #tt [value]="matchingOperatives" [globalFilterFields]="['fullName','referenceNumbers']"
                   styleClass="p-datatable-sm " [scrollable]="!isOnMobile && matchingOperatives?.length > 5" scrollHeight="500px" [responsive]="true"
                   [columns]="columns">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 12%">Name</th>
                <th style="width: 12%">Reference Nos</th>
                <th style="width: 10%">Started On</th>
                <th style="width: 10%">Ended On</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-operative let-columns="columns">
              <tr>
                <td *ngFor="let col of columns">
                  <span class="p-column-title">{{col.header}}: </span>
                  <span *ngIf="col.field === 'fullName'">
                    <a (click)="operativeSelected(operative)">{{operative[col.field]}}</a>
                  </span>
                  <span *ngIf="col.type==='text' && col.field !== 'fullName'">
                    {{ operative[col.field] }}
                  </span>
                  <span *ngIf="col.type==='date'">
                    {{ operative[col.field] | date : 'dd/MM/yyyy'}}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </ng-template>
      </p-panel>
    </div>
  </div>

  <hr />
  <p><strong>Engagement Details</strong></p>
  <div class="row">
    <!--Business Units-->
    <div class="col-xl-4 col-md-4 col-sm-12">
      <app-eca-select [options]="allBusinessUnits"
                      [(selectedId)]="operative.currentBusinessUnitId"
                      [isRequired]="false"
                      label="Business Unit"
                      placeholderText="Select a Value"
                      [isReadOnly]="!editingCurrentEngagement || allBusinessUnits?.length < 1"
                      [popoverText]="businessUnitHelpText">
      </app-eca-select>
    </div>
    <!--Operative Type-->
    <div class="col-xl-4 col-md-4 col-sm-12">
      <app-eca-select [options]="allOperativeTypes" [(selectedId)]="operative.currentOperativeTypeId"
                      [isRequired]="true"
                      [isValid]="!saveAttempted || !!operative.currentOperativeTypeId"
                      validationMessage="Please select an option"
                      label="Operative Type"
                      (selectedIdChange)="updateJobTitles($event,true)"
                      [isReadOnly]="!editingCurrentEngagement"
                      popoverText="Select the Type that best suits the Operatives current role">
      </app-eca-select>
    </div>
    <!--Job Title-->
    <div class="col-xl-4 col-md-4 col-sm-12">
      <app-eca-select [options]="filteredJobTitles" [(selectedId)]="operative.currentJobTitleId"
                      [isRequired]="true"
                      [isValid]="!saveAttempted || !!operative.currentJobTitleId"
                      validationMessage="Please select an option"
                      label="Job Role"
                      (selectedIdChange)="updateJobLevel($event,true)"
                      [isReadOnly]="!editingCurrentEngagement"
                      [showUpdateMessage]="showJobTitleUpdate"
                      [updateMessage]="'Job Role was updated after Operative Type change.'"
                      popoverText="Choose the Job Role that best fits the operative's role">
      </app-eca-select>
    </div>
    <!--Job Level-->
    <div class="col-xl-4 col-md-4 col-sm-12">
      <app-eca-select [options]="filteredJobLevels"
                      [(selectedId)]="operative.currentJobLevelId"
                      [isRequired]="true"
                      label="Job Level"
                      [isReadOnly]="!editingCurrentEngagement || isNonElectricalJobRole || isQsRole"
                      [isValid]="!saveAttempted || !!operative.currentJobLevelId"
                      validationMessage="Please select an option"
                      [showUpdateMessage]="showJobLevelUpdate"
                      [updateMessage]="'Job Level was updated after Job Role change.'"
                      popoverText="Select the level the operative is currently working at. This level will default to the job role's level but can be overriden">
      </app-eca-select>
    </div>
    <!--Job Risk-->
    <div class="col-xl-8 col-md-8 col-sm-12">
      <app-eca-select [options]="filteredRisks" [(selectedId)]="operative.currentRiskId"
                      [isRequired]="true"
                      class="full-width-input"
                      label="Degree of Risk in the Electrotechnical Work"
                      [isReadOnly]="!editingCurrentEngagement  || isNonElectricalJobRole"
                      [isValid]="!saveAttempted || !!operative.currentRiskId"
                      validationMessage="Please select an option"
                      popoverText="Please enter the Degree of Risk in the Electrotechnical Work covered by BS 7671 that the operative is currently engaged in.">
      </app-eca-select>
    </div>
  </div>
  <div class="row">
    <!--Start Date-->
    <div class="col-xl-4 col-md-6 col-sm-12">
      <app-eca-date-picker [isDisabled]="!editingCurrentEngagement" [controlId]="'ctrlLatestEngagementFrom'"
                           [dateValue]="operative.latestEngagementFrom"
                           (dateValueChange)="disableDatesPriorSelected(operative.latestEngagementFrom)"
                           label="Start Date"
                           [maxDate]="operativeMaxDate"
                           [isRequired]="true" [isValid]="!saveAttempted || !!operative?.latestEngagementFrom?.dateTime "
                           validationMessage="Please enter the date that these operative details are active from."
                           popoverText="Please enter the date that these operative details are active from. This could be the work start date for the operative or when they change job role etc.">
      </app-eca-date-picker>
    </div>
    <!--End Date-->
    <div class="col-xl-4 col-md-6 col-sm-12">
      <app-eca-date-picker [isDisabled]="!editingCurrentEngagement" [controlId]="'ctrlLatestEngagementTo'"
                           [dateValue]="operative.latestEngagementTo"
                           (dateValueChange)="disableDatesPostSelected(operative.latestEngagementTo)"
                           [minDate]="operativeMinDate"
                           label="End Date"
                           [isRequired]="false"
                           popoverText="Please enter the date that this change to the operative ends. You may leave this blank to indicate that the current changes are ongoing.">
      </app-eca-date-picker>
    </div>
    <!--Employment Status-->
    <div class="col-xl-4 col-md-6 col-sm-12">
      <app-eca-select [options]="allEmploymentStatuses" [(selectedId)]="operative.currentEmploymentStatusId"
                      [isRequired]="true"
                      class="full-width-input"
                      label="Employment Status"
                      [isReadOnly]="!editingCurrentEngagement"
                      [isValid]="!saveAttempted || !!operative.currentEmploymentStatusId"
                      validationMessage="Please select the employment status for the operative."
                      popoverText="Please select the employment status for the operative.">
      </app-eca-select>
    </div>
  </div>
</div>
